import { ETheme, Spinner } from "@/dependencies";
import React from "react";

export const LazyLoadingSpinner: React.FC = () => {
  return (
    <div
      className='loading-spinner'
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }}
    >
      <Spinner size='large' theme={ETheme.Light} />
    </div>
  );
};
